export default class Kt {
  constructor(t, s, i, h, l, e, r, u) {
    (this.ol = t || 0),
      (this.fl = s || []),
      (this.bl = i || []),
      (this.dl = h || []),
      (this.wl = l),
      (null != l && "" !== l) || (this.wl = null),
      (this.gl = e || null),
      (this.ml = r || {}),
      (this.hi = u || {});
  }
  ss() {
    return {
      s: "4.7.2",
      l: this.ol,
      e: this.fl,
      a: this.bl,
      p: this.dl,
      m: this.wl,
      v: this.gl,
      c: this.ml,
      f: this.hi
    };
  }
  static Pn(t) {
    let s = t.l;
    return (
      "4.7.2" !== t.s && (s = 0), new Kt(s, t.e, t.a, t.p, t.m, t.v, t.c, t.f)
    );
  }
}
